import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';

import VueYoutube from 'vue-youtube';
Vue.use(VueYoutube);

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },

  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue'),
  },
  {
  path: '/aidashboard',
  name: 'AIDashboard',
  component: () => import('../components/AIDashboard100325.vue'),
},
  {
  path: '/researchcontacts',
  name: 'ResearchContacts',
  component: () => import('../components/ResearchContacts.vue'),
},
  {
  path: '/promptrunner',
  name: 'PromptRunner',
  component: () => import('../components/PromptRunnerWorking.vue'),
},
  {
  path: '/aiartistanalystv2',
  name: 'AiArtistAnalystv2',
  component: () => import('../components/AiArtistAnalystv2.vue'),
},
 {
    path:'/program',
    name:'Program',
    component: () => import('../views/Program.vue'),
  },
  {
    path:'/eventplanner',
    name:'EventPlanner',
    component: () => import('../views/EventPlanner.vue'),
  },
  {
    path: '/notes',
    name: 'Notes',
    component: () => import('../components/Notes.vue'),
  },
  {
  path: '/viewer',
  component: () => import('@/components/Viewer.vue'),
},

  {
    path: '/callgpt',
    name: 'CallGPT',
    component: () => import('../components/CallGPT.vue'),
  },
  {
    path: '/tourrouter',
    name: 'TourRouter',
    component: () => import('../components/TourRouter.vue'),
  },
    {
    path: '/leadfinder',
    name: 'LeadFinder',
    component: () => import('../views/LeadFinder.vue'),
  },
  {
    path: '/bookgenerator',
    name: 'BookGenerator',
    component: () => import('../components/BookGenerator.vue'),
  },
  {
    path: '/businessdirectory',
    name: 'BusinessDirectory',
    component: () => import('../views/BusinessDirectory.vue'),
  },
    {
    path: '/gptvoice',
    name: 'GPTVoice',
    component: () => import('../views/GPTVoice.vue'),
  },
  {
    path: '/generativeai',
    name: 'GenerativeAI',
    component: () => import('../components/GenerativeAI.vue'),
  },
  {
    path: '/touraiAssistant',
    name: 'TourAIAssistant',
    component: () => import('../components/TourAIAssistant2.vue'),
  },
  {
    path: '/artistdashboard',
    name: 'ArtistDashboard',
    component: () => import('../components/ArtistDashboard.vue'),
  },
    {
    path: '/artistgallery',
    name: 'ArtistGallery',
    component: () => import('../components/ArtistGallery.vue'),
  },
   {
    path: '/artisttours',
    name: 'ArtistTours',
    component: () => import('../views/ArtistTours copy 3.vue'),
  },
     {
    path: '/touranalyst',
    name: 'TourAnalyst',
    component: () => import('../views/TourAnalyst.vue'),
  },
  {
    path: '/artisttoursanalyst',
    name: 'ArtistToursAnalyst',
    component: () => import('../views/ArtistTours copy 3.vue'),
  },
  {
    path: '/bookgeneratorworking',
    name: 'BookGeneratorWorking',
    component: () => import('../components/BookGeneratorWorking.vue'),
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../components/News.vue'),
  },
  // {
  //   path: '/vectorai',
  //   name: 'VectorAI',
  //   component: () => import('../components/vectorai/VectorAI.vue'),
  // },
  {
    path: '/intel',
    name: 'Intel',
    component: () => import('../views/Intel.vue'),
  },
  {
    path: '/pos',
    name: 'Pos',
    component: () => import('../views/Pos.vue'),
  },
  {
    path: '/posdemo',
    name: 'PosDemo',
    component: () => import('../views/PosDemo.vue'),
  },
  {
    path: '/googlevoicesearch',
    name: 'GoogleVoiceSearch',
    component: () => import('../views/GoogleVoiceSearch.vue'),
  },
  {
    path: '/browserbot',
    name: 'BrowserBot',
    component: () => import('../views/BrowserBot.vue'),
  },
  {
    path: '/ai',
    name: 'AI',
    component: () => import('../views/AI.vue'),
  },
  {
    path: '/sales',
    name: 'Sales',
    component: () => import('../views/Sales.vue'),
  },
  {
    path: '/leads',
    name: 'Leads',
    component: () => import('../views/Leads.vue'),
  },
  {
    path: '/aimixer',
    name: 'AIMixer',
    component: () => import('../views/AIMixer.vue'),
  },
  // {
  //   path: '/proposals',
  //   name: 'Proposals',
  //   component: () => import('../views/Proposals.vue'),
  // },
  // {
  //   path: '/accounts',
  //   name: 'Accounts',
  //   component: () => import('../views/Accounts.vue'),
  // },
  // {
  //   path: '/contacts',
  //   name: 'Contacts',
  //   component: () => import('../views/Contacts.vue'),
  // },
  // {
  //   path: '/invoices',
  //   name: 'Invoices',
  //   component: () => import('../views/Invoices.vue'),
  // },
  {
    path: '/brain',
    name: 'Brain',
    component: () => import('../views/Brain.vue'),
  },
  {
    path: '/concierge',
    name: 'Concierge',
    component: () => import('../views/Concierge.vue'),
  },
  {
    path: '/canvas',
    name: 'Canvas',
    component: () => import('../views/Canvas.vue'),
  },
    {
    path: '/scenegenerator',
    name: 'SceneGenerator',
    component: () => import('../views/SceneGenerator.vue'),
  },
      {
    path: '/projectsgallery',
    name: 'ProjectsGallery',
    component: () => import('../components/ProjectsGallery.vue'),
  },
        {
    path: '/artistbooking',
    name: 'ArtistBooking',
    component: () => import('../views/ArtistBookingInfo.vue'),
  },
        {
    path: '/askprg',
    name: 'AskPRG',
    component: () => import('../views/GPTVoice.vue'),
  },
          {
    path: '/movieanalyst',
    name: 'MovieAnalyst',
    component: () => import('../views/MovieAnalyst.vue'),
  },
          {
    path: '/aicoach',
    name: 'AICoach',
    component: () => import('../views/AICoach.vue'),
  },
            {
    path: '/timer',
    name: 'Timer',
    component: () => import('../views/Timer.vue'),
  },
  {
    path: '/marketing',
    name: 'Marketing',
    component: () => import('../views/Marketing.vue'),
  },
  {
    path: '/codex',
    name: 'Codex',
    component: () => import('../views/Codex.vue'),
  },
  {
    path: '/cogdetective',
    name: 'CogDetective',
    component: () => import('../views/CogDetective.vue'),
  },
  // {
  //   path: '/phoneai',
  //   name: 'PhoneAI',
  //   component: () => import('../views/PhoneAI.vue'),
  // },
  {
    path: '/detective',
    name: 'Detective',
    component: () => import('../views/Detective.vue'),
  },
  {
    path: '/analyst',
    name: 'Analyst',
    component: () => import('../views/Analyst.vue'),
  },
  {
    path: '/artisttracker',
    name: 'ArtistTracker',
    component: () => import('../views/ArtistTracker.vue'),
  },
    {
    path: '/trainingagent',
    name: 'TrainingAgent',
    component: () => import('../views/TrainingAgent.vue'),
  },
      {
    path: '/trainincommands',
    name: 'TrainingCommands',
    component: () => import('../views/TrainingCommands.vue'),
  },
        {
    path: '/shadowbox',
    name: 'ShadowBox',
    component: () => import('../views/ShadowBox.vue'),
  },
  {
    path: '/artisttrackernew',
    name: 'ArtistTrackerNew',
    component: () => import('../views/ArtistTrackerNew.vue'),
  },
   {
    path: '/artistanalyst',
    name: 'ArtistAnalyst',
    component: () => import('../views/ArtistAnalyst.vue'),
  },
  {
    path: '/tourpredictdashboard',
    name: 'TourPredictDashboard',
    component: () => import('../components/TourPredictDashboard.vue'),
  },
    {
    path: '/tourprediction',
    name: 'TourPrediction',
    component: () => import('../components/TourPrediction.vue'),
  },
      {
    path: '/tourpredictionnew',
    name: 'TourPredictionNew',
    component: () => import('../components/TourPrediction102425.vue'),
  },
  {
    path: '/artisttrackersearch',
    name: 'ArtistTrackerSearch',
    component: () => import('../views/ArtistTrackerSearch.vue'),
  },
  {
    path: '/generative',
    name: 'Generative',
    component: () => import('../views/Generative.vue'),
  },
  {
    path: '/codexcode',
    name: 'CodexCode',
    component: () => import('../views/CodexCode.vue'),
  },
  {
    path: '/codexdata',
    name: 'CodexData',
    component: () => import('../views/CodexData.vue'),
  },
  {
    path: '/researchassistant',
    name: 'ResearchAssistant',
    component: () => import('../views/ResearchAssistant.vue'),
  },
    {
    path: '/artistreport',
    name: 'ArtistReport',
    component: () => import('../views/ArtistReport.vue'),
  },
  {
    path: '/artistresearch',
    name: 'ArtistResearch',
    component: () => import('../components/ArtistResearch.vue'),
  },
  {
    path: '/researchassist',
    name: 'ResearchAssist',
    component: () => import('../views/ResearchAssist.vue'),
  },
  {
    path: '/cogassistant',
    name: 'CogAssistant',
    component: () => import('../views/CogAssistant.vue'),
  },
  {
    path: '/cogdetective',
    name: 'CogDetective',
    component: () => import('../views/CogDetective.vue'),
  },
  {
    path: '/generative',
    name: 'Generative',
    component: () => import('../views/Generative.vue'),
  },
  {
    path: '/codexdata',
    name: 'CodexData',
    component: () => import('../views/CodexData.vue'),
  },
  {
    path: '/ai',
    name: 'AI',
    component: () => import('../views/AI.vue'),
  },
  {
    path: '/codexcode',
    name: 'CodexCode',
    component: () => import('../views/CodexCode.vue'),
  },
  {
    path: '/voicebrowsersearch',
    name: 'VoiceBrowserSearch',
    component: () => import('../views/VoiceBrowserSearch.vue'),
  },
  {
    path: '/creator',
    name: 'Creator',
    component: () => import('../views/Creator.vue'),
  },
  {
    path: '/designer',
    name: 'Designer',
    component: () => import('../views/Designer.vue'),
  },
  {
    path:'/program',
    name:'Program',
    component: () => import('../views/Program.vue'),
  },
  {
    path: '/analytics',
    name: 'Analytics',
    component: () => import('../views/Analytics.vue'),
  },
  {
    path: '/stock-analysis',
    name: 'StockAnalysis',
    component: () => import('../components/StockCog.vue'),
  },
  {
    path: '/assistant',
    name: 'Assistant',
    component: () => import('../components/Assistant.vue'),
  },
  {
    path: '/cogassist',
    name: 'CogAssist',
    component: () => import('../components/CogAssist.vue'),
  },
  {
    path: '/workspace',
    name: 'Workspace',
    component: () => import('../views/Workspace.vue'),
  },
  {
    path: '/translate',
    name: 'Translate',
    component: () => import('../views/Translate.vue'),
  },
  {
    path: '/workspaceai',
    name: 'WorkspaceAI',
    component: () => import('../views/WorkspaceAI.vue'),
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/dailybriefing',
    name: 'DailyBriefing',
    component: () => import('../views/DailyBriefing.vue'),
  },
  {
    path: '/directory',
    name: 'Directory',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Directory.vue'),
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/Users.vue'),
  },
  {
    path: '/chat',
    name: 'Chat',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Chat.vue'),
  },
  {
    path: '/calendar',
    name: 'Calendar',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Calendar.vue'),
  },

  {
    path: '/dashboard',
    name: 'Dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Dashboard.vue'),
  },
  {
    path: '/userdashboard',
    name: 'UserDashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/UserDashboard.vue'),
  },
  {
    path: '/interface',
    name: 'Interface',
    component: () => import('../views/Interface.vue'),
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('../views/Test.vue'),
  },
  // {
  //   path: '/welcome',
  //   name: 'Welcome',
  //   component: () => import('../views/Welcome.vue'),
  // },
  {
    path: '/missioncontrol',
    name: 'MissionControl',
    component: () => import('../views/MissionControl.vue'),
  },
  {
    path: '/experience',
    name: 'Experience',
    component: () => import('../views/Experience.vue'),
  },
  {
    path: '/map',
    name: 'Map',
    component: () => import('../views/Map.vue'),
  },
  {
    path: '/earth',
    name: 'Earth',
    component: () => import('../views/Earth.vue'),
  },
  {
    path: '/videoplayer',
    name: 'VideoPlayer',
    component: () => import('../views/VideoPlayer.vue'),
  },
  {
    path: '/videosearch',
    name: 'VideoSearch',
    component: () => import('../views/VideoSearch.vue'),
  },
  {
    path: '/tasks',
    name: 'Tasks',

    component: () => import('../views/Tasks.vue'),
  },
  {
    path: '/videocall',
    name: 'VideoCall',
    component: () => import('../views/VideoChat.vue'),
  },
  {
    path: '/video',
    name: 'Video',
    component: () => import('../components/FaceDetection.vue'),
  },
  {
    path: '/emailnotify',
    name: 'EmailNotify',
    component: () => import('../views/EmailNotify.vue'),
  },
  {
    path: '/email',
    name: 'email',
    component: () => import('../views/Email.vue'),
  },

  {
    name: 'Email',
    path: '/email/inbox',
    component: () => import('../views/Email.vue'),
    children: [
      {
        path: '/email/:mailType',
        name: 'MailIndex',
        component: () => import('@/views/apps/email/EmailList.vue'),
      },
      {
        path: '/email/:mailType/0/:uuid',
        name: 'MailDetail1',
        component: () => import('@/views/apps/email/EmailDetail.vue'),
      },
      {
        path: '/email/0/:mailTag',
        name: 'MailTag',
        component: () => import('@/views/apps/email/EmailList.vue'),
      },
      {
        path: '/email/0/:mailTag/0/:uuid',
        name: 'MailDetail',
        component: () => import('@/views/apps/email/EmailDetail.vue'),
      },
    ],
  },
];


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
